<script lang="ts">
    interface Props {
        href?: string;
        title: string;
        class?: string;
    }

    let { href, title, class: className = '' }: Props = $props();
</script>

<a class="button {className}" {href}>{title}</a>

<style>
    @media (width >= 300px) {
        .button {
            display: inline-block;
            text-decoration: none;
            background-color: var(--light-sky);
            font-family: var(--serif);
            font-size: clamp(var(--h5), 2vw, var(--h3));
            font-weight: 900;
            border: 1px solid var(--blackest);
            outline: 3px solid var(--blackest);
            color: var(--blackest);
            border-radius: var(--radius);
            outline-offset: -7px;
            margin-inline: auto;
            cursor: pointer;
            letter-spacing: 2px;
            width: fit-content;
            transition:
                outline-offset 300ms ease-out,
                opacity 300ms ease-out,
                scale 0.15s ease-out;
            padding: var(--padding-button);
            user-select: none;

            &:not(:hover) {
                opacity: 0.85;
            }

            &:focus-visible {
                outline: 1px solid var(--clr-light-500);
                background: transparent;
            }

            &:hover {
                outline-offset: 0px;
            }

            &:active {
                scale: 0.95;
            }
        }
    }
</style>
